import { render, staticRenderFns } from "./Tourism.vue?vue&type=template&id=ca7eccda&"
import script from "./Tourism.vue?vue&type=script&lang=js&"
export * from "./Tourism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports